export enum OrganisationEditStep {
    ACTIVITY = 'ACTIVITY',
    NOTE = 'NOTE',
    COMMENT = 'COMMENT',
    EMAIL = 'EMAIL',
    TASK = 'TASK',
    MEET= 'MEET',
    INFO = 'INFO',
}